











































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
const OutgoingInvoices = namespace("InvoicesModule");
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";

import "vue2-datepicker/scss/index.scss";
import Paginate from "@/components/Paginate.vue";

@Component({
  name: "OutgoingInvoice",
  components: {
    DatePicker,
    Paginate,
    Multiselect,
  },
  filters: {
    formatDate: function (value: any) {
      if (!value) {
        return "";
      }
      const cDate = new Date(value);

      return (
        cDate.getFullYear() +
        "-" +
        String(cDate.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(cDate.getDate()).padStart(2, "0")
      );
    },
  },
})
export default class OutgoingInvoice extends Vue {
  private urlRetrieve = 'invoices/outgoing/search';
  private urlTotalAmount = 'invoices/outgoing/total-amount';
  private status = false;
  private currency = "EUR";
  private isLoading = false;

  //@TODO: get airline List from DB - wait task debtor infomation
  private airlineList = [
    { value: null, text: "Airline" },
    { value: 40000002, text: "Airline2" },
    { value: 40000001, text: "Airline1" },
    { value: 40000003, text: "Airline3" },
  ];
  private CreditorNameList = [];
  private totalInfo = {
    TotalAmountOverdue: 0,
    TotalAmountOustanding: 0,
    FilterAmountOverdue: 0,
    FilterAmountOustanding: 0,
  };
  private paidStatusOptions = [
    { value: null, text: "Status" },
    { value: 1, text: "Paid" },
    { value: 2, text: "UnPaid" },
    { value: 3, text: "Disputed" },
  ];
  private invoices = [];
  private SortDate: any = null;
  private SortAmount: any = null;
  private SortOverDue: any = null;
  private SortRemindersSend: any = null;
  private filter = {
    Debtor: null,
    DateFrom: new Date(),
    DateTo: new Date(),
    InvoiceNr: null,
    FlightNumber: null,
    Airport: null,
    FlightDate: null,
    CreditorName: null,
    Debitor: null,
    Amount: null,
    InvoiceType: null,
    PaidStatus: null,
    RemindersSend: null,
    DateOfPayment: null,
    DueDate: null,
    GetOverDue: false,
    sort: "",
    index: "",
  };
  private invoiceTypeOptions = [
    { value: null, text: "Invoice Type" },
    { value: "D", text: "Debit" },
    { value: "C", text: "Credit" },
  ];
  invoiceTypeValue = {
    D: "Debit",
    C: "Credit",
  };
  private paginate = {
    perPage: 0,
    totalRow: 0,
    currentPage: 0,
    limit: 0,
  };

  constructor() {
    super();
  }
  created() {
    this.searchData();
    this.calTotalAmount();
  }
  pageChange(params: any) {
    this.getItemPerPage({
      page: params.currentPage,
      filter: this.filterQuery(),
    }).then(
      (response) => {
        this.invoices = response.invoiceList;
        if (response.Paginate) {
          this.paginate = response.Paginate;
          this.CreditorNameList = this.creditorOptionList;
        }
      }
    );
  }
  public sortDate(): void {
    if (this.SortDate == null) {
      this.SortDate = "desc";
    } else {
      this.SortDate = this.SortDate == "desc" ? "asc" : "desc";
    }
    this.filter.sort = this.SortDate;
    this.filter.index = "InvoiceDateSort";
    this.SortAmount = null;
    this.SortOverDue = null;
    this.SortRemindersSend = null;
    this.searchData();
  }

  public sortAmount(): void {
    if (this.SortAmount == null) {
      this.SortAmount = "desc";
    } else {
      this.SortAmount = this.SortAmount == "desc" ? "asc" : "desc";
    }
    this.SortDate = null;
    this.SortOverDue = null;
    this.SortRemindersSend = null;
    this.filter.sort = this.SortAmount;
    this.filter.index = "AMountTotalInclVAT";
    this.searchData();
  }

  public sortOverDue(): void {
    if (this.SortOverDue == null) {
      this.SortOverDue = "desc";
    } else {
      this.SortOverDue = this.SortOverDue == "desc" ? "asc" : "desc";
    }
    this.SortDate = null;
    this.SortAmount = null;
    this.SortRemindersSend = null;
    this.filter.sort = this.SortOverDue;
    this.filter.index = "DueDate";
    this.searchData();
  }

  public sortRemindersSend(): void {
    if (this.SortRemindersSend == null) {
      this.SortRemindersSend = "desc";
    } else {
      this.SortRemindersSend = this.SortRemindersSend == "desc" ? "asc" : "desc";
    }
    this.SortDate = null;
    this.SortAmount = null;
    this.SortOverDue = null;
    this.filter.sort = this.SortRemindersSend;
    this.filter.index = "SortRemindersSend";
    // this.searchData();
  }

  public calTotalAmount(): void {
    //get total amount for all
    this.getTotalAmount({url: this.urlTotalAmount, data:{
      DateFrom: this.getDateString(this.filter.DateFrom),
      DateTo: this.getDateString(this.filter.DateTo),
      Filter: [],
    }}).then((response) => {
      this.totalInfo.TotalAmountOverdue = response.data[0].TotalAmountOverDue;
      this.totalInfo.TotalAmountOustanding = response.data[0].TotalAmount;
    });

    //get total amount for filter
    //get total amount for all
    this.getTotalAmount({url: this.urlTotalAmount, data:{
      DateFrom: this.getDateString(this.filter.DateFrom),
      DateTo: this.getDateString(this.filter.DateTo),
      Filter: this.makeFilter(),
    }}).then((response) => {
      this.totalInfo.FilterAmountOverdue = response.data[0].TotalAmountOverDue;
      this.totalInfo.FilterAmountOustanding = response.data[0].TotalAmount;
    });
  }

  public searchData(): void {
    this.isLoading = true;
    this.retrieveInvoices(this.filterQuery()).then(
      (response) => {
        this.paginate = response.Paginate;
        this.invoices = response.invoiceList;
        this.CreditorNameList = this.creditorOptionList;
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
      }
    );
    this.calTotalAmount();
  }

  private filterQuery() {
    const filter = this.filter;
    const filterData: any = {};
    //we will search from Datefrom at default
    //@TODO: if the sort order is descending and sort type is invoicedate, we will start from dateto
    const dateFrom = filter.DateFrom == null ? new Date() : filter.DateFrom;
    const searchYear = dateFrom.getFullYear();
    filterData.PartitionKey = searchYear;

    //index using and sort
    if (filter.index) {
      filterData.Index = filter.index;
    }
    if (filter.sort) {
      filterData.Sort = filter.sort;
    }
    filterData.Filter = this.makeFilter();
    if (!filter.GetOverDue) {
      filterData.Filter.push({
        Key: "IsOverDue",
        Value: 0,
      });
    }
    return {url: this.urlRetrieve, filterData: filterData};
  }

  private makeFilter() {
    const filter = this.filter;
    const Filter = [];
    const invoiceNr: any = filter.InvoiceNr;
    const debtor: any = filter.Debtor;
    Filter.push({
      Key: "InvoiceDate",
      Operator: "greatThanEqual",
      Value: this.getDateString(filter.DateFrom),
    });
    Filter.push({
      Key: "InvoiceDate",
      Operator: "lessThanEqual",
      Value: this.getDateString(filter.DateTo),
    });
    if (filter.Debtor) {
      Filter.push({
        Key: "Debtor",
        Value: parseInt(debtor),
      });
    }
    if (filter.InvoiceNr) {
      Filter.push({
        Key: "InvoiceNr",
        Value: parseInt(invoiceNr),
      });
    }
    if (filter.CreditorName) {
      Filter.push({
        Key: "CreditorName",
        Value: filter.CreditorName,
      });
    }
    if (filter.FlightNumber) {
      Filter.push({
        Key: "FlightNumber",
        Operator: "contains",
        Value: filter.FlightNumber,
      });
    }
    if (filter.FlightDate) {
      const dateF: Date = filter.FlightDate || new Date();
      Filter.push({
        Key: "FlightDate",
        Operator: "contains",
        Value: this.getDateString(dateF),
      });
    }
    if (filter.Airport) {
      Filter.push({
        Key: "AirportIataCode",
        Operator: "contains",
        Value: filter.Airport,
      });
    }
    if (filter.Amount) {
      Filter.push({
        Key: "Amount",
        Operator: "contains",
        Value: Number(filter.Amount),
      });
    }
    if (filter.InvoiceType) {
      Filter.push({
        Key: "InvoiceType",
        Value: filter.InvoiceType,
      });
    }
    if (filter.PaidStatus) {
      Filter.push({
        Key: "Status",
        Value: filter.PaidStatus,
      });
    }
    if (filter.DueDate) {
      const dateF: Date = filter.DueDate || new Date();
      Filter.push({
        Key: "DueDate",
        Value: this.getDateString(dateF),
      });
    }
    if (filter.DateOfPayment) {
      const dateF: Date = filter.DateOfPayment || new Date();
      Filter.push({
        Key: "DateOfPayment",
        Value: this.getDateString(dateF),
      });
    }
    return Filter;
  }

  getDateString(value: Date): string {
    value = value == null ? new Date() : value;
    return (
      value.getFullYear() +
      "-" +
      String(value.getMonth() + 1).padStart(2, "0") +
      "-" +
      String(value.getDate()).padStart(2, "0")
    );
  }

  notBeforeDateFrom(date: Date) {
    const dateFrom = new Date(this.filter.DateFrom);
    dateFrom.setHours(0, 0, 0, 0);
    return date.getTime() < dateFrom.getTime();
  }

  notAfterDateTo(date: Date) {
    const dateTo = new Date(this.filter.DateTo);
    dateTo.setHours(0, 0, 0, 0);
    return date.getTime() > dateTo.getTime();
  }

  @OutgoingInvoices.State
  public invoiceList!: Array<any>;

  @OutgoingInvoices.State
  public lastKey!: any;

  @OutgoingInvoices.State
  public creditorOptionList!: any;

  @OutgoingInvoices.Action
  public retrieveInvoices!: (params: any) => Promise<any>;

  @OutgoingInvoices.Action
  public getTotalAmount!: (params: any) => Promise<any>;

  @OutgoingInvoices.Action
  public getItemPerPage!: (params: any) => Promise<any>;
}
